import Constant from '@/const'
export default {
  namespaced: true,
  state: {
    data: {},
  },
  mutations: {
    create(state, data) {
      state.data = data
    },
    destroy(state) {},
  },
  actions: {
    // アカウント本登録
    async createAccount({ commit, dispatch }, data) {
      const request = {
        params: data,
        url: Constant.API_URL.REGISTER_VERIFY,
        // error: {message: '本登録に失敗しました。'}
        // error: {message: '正しいIDをご入力ください。'}
      }
      return dispatch('http/post', { ...request }, { root: true })
        .then((res) => {
          commit('create', res.data)
          return res
        })
        .catch((err) => {
          throw new Error(err.message)
        })
    },
    // アカウント本登録
    async changeMail({ commit, dispatch }, data) {
      const request = {
        params: data,
        url: Constant.API_URL.CHANGE_VERIFY,
        error: { message: '本登録に失敗しました。' },
      }
      return dispatch('http/post', { ...request }, { root: true })
        .then((res) => {
          commit('create', res.data)
          return res
        })
        .catch((err) => {
          throw new Error(err.message)
        })
    },
    // パスワード忘れ
    async forget({ commit, dispatch }, data) {
      const request = {
        params: data,
        url: `${Constant.API_URL.PASSWORD}/sendmail_forget`,
        // error: {message: '案内メール送信に失敗しました。'}
        error: { message: '正しいIDをご入力ください。' },
      }
      return dispatch('http/post', { ...request }, { root: true })
        .then((res) => {
          return res
        })
        .catch((err) => {
          throw new Error(err.message)
        })
    },
    // パスワード更新
    async updatePW({ commit, dispatch }, data) {
      const request = {
        params: data,
        url: `${Constant.API_URL.PASSWORD}/forget`,
        // error: {message: 'パスワード更新に失敗しました。'}
        // error: {message: '正しいIDをご入力ください。'}
      }
      return dispatch('http/post', { ...request }, { root: true })
        .then((res) => {
          commit('create', res.data)
          return res
        })
        .catch((err) => {
          throw new Error(err.message)
        })
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/password.js